import images from "../../assets/images/assets";
import StorySection from "./StorySection";

const StoryPage = () => {
  return (
    <div className="bg-transparent w-full p-4 relative">
      <div className="bg-transparent">
        <StorySection />
      </div>

      {/* Decorative Blur */}
      <img
        src={images.blur_2}
        alt="blur"
        className="absolute -left-50 -top-16 md:-left-100 lg:-left-200 saturate-150 mirror-x lg:-top-40 "
      />
    </div>
  );
};

export default StoryPage;
